import { Dispatch, RefObject, SetStateAction, createContext } from "react";
import { ItemMenu } from "../../../../../../../components/baseMenu";
import { ItemsEdit } from "../provider/types";
import { Types } from "../../../../../../../utils/enums";
import { ModalState } from "../../../../../../questionnaire/pages/detail/typing/types";
import { Item, Table } from "../../../../../../../utils/types/generals";
import { ResendRef } from "../../../../../../../components/resend/types";
import { SubmitResendReport } from "../../../../../../calendar/pages/main/types";
import { FolioType } from "../../../utils/enums/folioType";

export const ReportFolioDetailContext = createContext<{
    isUserAssigned: boolean
    ref: RefObject<ResendRef>
    errorsResend: string[]
    userTracking: string[]
    setTypeFolio: Dispatch<SetStateAction<FolioType>>
    setUserTracking: Dispatch<SetStateAction<string[]>>
    submitResendReport: ({ id, data, }: SubmitResendReport) => void
    setErrorsResend: Dispatch<SetStateAction<string[]>>
    unsubscribeUserFromTheFolio: () => void
    confirmReturn: () => void
    callCancelEndpoints: () => void
    changeReportFolio: boolean
    handleExit: () => void
    setChangeReportFolio: Dispatch<SetStateAction<boolean>>
    setLoadingUsers: Dispatch<SetStateAction<boolean>>
    loadingUsers: boolean
    setTableData: Dispatch<SetStateAction<Table>>
    tableData: Table
    setUserSelected: Dispatch<SetStateAction<number | null | undefined>>
    userSelected: number | null | undefined
    setApiBusy: Dispatch<SetStateAction<boolean>>
    apiBusy: boolean
    setModalReassign: Dispatch<SetStateAction<boolean>>
    modalReassign: boolean
    reassignUser: () => void
    optionSelected: ItemMenu | null
    callReassignAreaAndDepartmentEndpoint:() => void
    setUserAssigned: Dispatch<SetStateAction<Item[]>>
    userAssigned: Item[]
    selectOption: (item: ItemMenu | null) => void
    items: ItemsEdit
    callEditEndpoint: () => void
    creatorUser: {
        user?: string;
        date?: string;
        id?: string | number | null;
    }
    setCreatorUser: Dispatch<SetStateAction<{
        user?: string;
        date?: string;
        id?: string | number | null;
    }>>
    statusAttencion: {
        statusAttentionId: number | null;
        userAttendingId: number | null;
    }
    setStatusAttention: Dispatch<SetStateAction<{
        statusAttentionId: number | null;
        userAttendingId: number | null;
    }>>
    snackbar: {
        message: string;
        open: boolean;
        type: Types;
    }
    setSnackbar: Dispatch<SetStateAction<{
        message: string;
        open: boolean;
        type: Types;
    }>>
    closeSnackbar: () => void
    callReassignUserEndpoint: () => void
    setLoadings: Dispatch<SetStateAction<{
        update: boolean;
        next: boolean;
        resend: boolean;
    }>>
    loadings: {
        update: boolean;
        next: boolean;
        resend: boolean;
    }
    modal: ModalState
    setModal: Dispatch<SetStateAction<ModalState>>
    closeModal: () => void
}>(Object({}))